export default function getUri() {
  return new URL(window.location.href);
}
